import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Leaf, ShoppingBag, MessageCircle } from 'lucide-react';
import SalesContainer from './SalesContainer';
import SubscribeSection from './subscription';
import '../styles/home.css';

function Home() {
  return (
    <main className="store-home">
      <section className="store-hero store-shell" aria-labelledby="hero-title">
        <div className="hero-copy">
          <span className="hero-eyebrow"><Leaf size={16} /> YOUR AFRICAN GROCERY STORE · 2026</span>
          <h1 id="hero-title">A taste of home.<br /><span>Fresh for your table.</span></h1>
          <p>Bring your favourite African flavours to everyday meals. Explore fresh produce, pantry essentials and rich spices, all in one place.</p>
          <div className="hero-actions">
            <a className="store-button" href="#shop">Shop groceries <ArrowUpRight size={20} /></a>
            <Link className="store-button store-button-light" to="/onsale">Explore offers</Link>
          </div>
          <div className="hero-note"><ShoppingBag size={18} /> Familiar favourites. More delicious possibilities.</div>
        </div>
        <div className="hero-produce">
          <img className="hero-main-image" src="/images/plantain.webp" alt="Fresh plantains for your favourite recipes" fetchPriority="high" />
          <div className="hero-image-label"><span>FROM OUR GROCERY STORE</span><strong>Good food. Rooted in culture.</strong></div>
          <img className="hero-inset-image" src="/images/okra.webp" alt="Fresh okra" />
          <span className="hero-fresh-tag"><Leaf size={16} /> Fresh favourites</span>
        </div>
      </section>
      <div className="store-benefits store-shell">
        <div><Leaf size={22} /><span><strong>Authentic flavours</strong>African food & pantry essentials</span></div>
        <div><ShoppingBag size={22} /><span><strong>Shop your way</strong>Browse, search & build your basket</span></div>
        <a href="https://wa.me/16479912413" target="_blank" rel="noopener noreferrer"><MessageCircle size={22} /><span><strong>Here to help</strong>Chat with us on WhatsApp</span><ArrowUpRight size={18} /></a>
      </div>
      <section id="shop" aria-label="Shop groceries"><SalesContainer /></section>
      <section className="store-promo store-shell">
        <div><span className="hero-eyebrow">MAKE ROOM FOR YOUR FAVOURITES</span><h2>Your next great meal starts here.</h2><p>Discover special offers and stock up on the flavours you love.</p></div>
        <Link className="store-button" to="/onsale">Browse offers <ArrowUpRight size={20} /></Link>
      </section>
      <SubscribeSection />
    </main>
  );
}
export default Home;
